/* eslint-disable react/no-unknown-property */
import React from "react";

interface Props {
  color?: string;
}

export const AvatarIcon = (props: Props) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.87109 22.6633C1.87109 20.5415 2.71395 18.5067 4.21424 17.0064C5.71453 15.5061 7.74936 14.6633 9.87109 14.6633C11.9928 14.6633 14.0277 15.5061 15.5279 17.0064C17.0282 18.5067 17.8711 20.5415 17.8711 22.6633H15.8711C15.8711 21.072 15.239 19.5458 14.1137 18.4206C12.9885 17.2954 11.4624 16.6633 9.87109 16.6633C8.27979 16.6633 6.75367 17.2954 5.62845 18.4206C4.50323 19.5458 3.87109 21.072 3.87109 22.6633H1.87109ZM9.87109 13.6633C6.55609 13.6633 3.87109 10.9783 3.87109 7.66327C3.87109 4.34827 6.55609 1.66327 9.87109 1.66327C13.1861 1.66327 15.8711 4.34827 15.8711 7.66327C15.8711 10.9783 13.1861 13.6633 9.87109 13.6633ZM9.87109 11.6633C12.0811 11.6633 13.8711 9.87327 13.8711 7.66327C13.8711 5.45327 12.0811 3.66327 9.87109 3.66327C7.66109 3.66327 5.87109 5.45327 5.87109 7.66327C5.87109 9.87327 7.66109 11.6633 9.87109 11.6633ZM22.4191 1.44727C23.3773 3.37909 23.8743 5.50686 23.8711 7.66327C23.8711 9.89627 23.3481 12.0073 22.4191 13.8793L20.7741 12.6833C21.4993 11.1092 21.8736 9.39633 21.8711 7.66327C21.8711 5.87127 21.4781 4.17027 20.7741 2.64327L22.4191 1.44727ZM19.1171 3.84727C19.6165 5.05742 19.8727 6.3541 19.8711 7.66327C19.8727 8.97243 19.6165 10.2691 19.1171 11.4793L17.4401 10.2593C17.7263 9.4237 17.8719 8.54647 17.8711 7.66327C17.8722 6.78011 17.7269 5.90289 17.4411 5.06727L19.1171 3.84727Z"
      fill={props.color ?? "#F43636"}
    />
  </svg>
);
